export default __webpack_public_path__ + "static/media/lock.de47df3a.svg";